import { NAME } from './constants';

export const COMPLETE_CURRENT_PROGRESS = `${NAME}/COMPLETE_CURRENT_PROGRESS`;
export const RESET = `${NAME}/RESET`;
export const SET_PROCESS = `${NAME}/SET_PROCESS`;
export const SET_SIDEBAR_FORM_VALUES_CACHE = `${NAME}/SET_SIDEBAR_FORM_VALUES_CACHE`;
export const SET_PROGRESS = `${NAME}/SET_PROGRESS`;
